// import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PeerAI from "./PeerAI/PeerAI";
import { Actions } from "./PeerAI/Components/Actions/Actions";
import React from "react";
// import { useMsal } from "@azure/msal-react";
import { msalInstance } from "./msalconfig";
import { MsalProvider } from "@azure/msal-react";
import AuthWrapper from "./AuthWrapper";
// import { InteractionType } from "@azure/msal-browser";
// import Login from "./PeerAI/Login";



const App = () => {
 
 return (
    <MsalProvider instance={msalInstance}>
    <Router>
      <AuthWrapper>
        <Routes>
          <Route path="/" element={<PeerAI />} />
          <Route path="/actions" element={<Actions />} />
        </Routes>
      </AuthWrapper>
    </Router>
  </MsalProvider>
  );
};


 export default App;
